const BASE_URL = '//pluto.tv';

const urlsConfig = {
  welcome: {
    url: {
      default: `${BASE_URL}/welcome`,
      uk: 'https://www.eu-landing.corp.pluto.tv/welcome',
      gsa: 'https://www.de-landing.corp.pluto.tv/welcome',
    },
    hide: ['latam', 'es', 'br', 'fr'],
  },
  about_us: {
    url: `${BASE_URL}/about-us`,
    hide: ['latam', 'gsa', 'uk', 'es', 'br', 'fr'],
  },
  careers: {
    url: {
      default: `${BASE_URL}/careers`,
      uk: 'https://www.eu-landing.corp.pluto.tv/jobs',
      gsa: 'https://www.de-landing.corp.pluto.tv/jobs',
      es: 'https://www.es-landing.corp.pluto.tv/jobs',
    },
    hide: ['latam', 'br', 'fr'],
  },
  where_to_watch: {
    url: `${BASE_URL}/where-to-watch`,
    hide: ['latam', 'gsa', 'uk', 'es', 'br', 'fr'],
  },
  partners: {
    url: `${BASE_URL}/partners`,
    hide: ['latam', 'gsa', 'uk', 'es', 'br', 'fr'],
  },
  support: {
    url: {
      default: 'https://support.pluto.tv/',
      latam: 'https://soporte.pluto.tv/',
      es: 'https://soporte.pluto.tv/',
      br: 'https://support.pluto.tv/hc/pt-br/',
      fr: 'https://support.pluto.tv/hc/fr',
    },
    hide: ['gsa', 'uk', 'es'],
  },
  terms_of_use: {
    url: {
      default: 'https://corporate.pluto.tv/terms-of-use',
      latam: 'https://corporate.pluto.tv/terms-of-use-latam/',
      gsa: 'https://www.de-landing.corp.pluto.tv/impressum',
      uk: 'https://www.eu-landing.corp.pluto.tv/legal-notice',
      es: 'https://www.eu-landing.corp.pluto.tv/terminos-de-uso',
      br: 'https://corporate.pluto.tv/terms-of-use-brazil/',
      fr: 'https://www.fr-landing.corp.pluto.tv/conditions-dutilisation',
    },
  },
  terms_and_conditions: {
    url: {
      fr: 'https://www.fr-landing.corp.pluto.tv/conditions-generales',
    },
    hide: ['latam', 'gsa', 'uk', 'es', 'br', 'us'],
  },
  privacy_policy: {
    url: {
      default: 'https://corporate.pluto.tv/privacy-policy',
      latam: 'https://corporate.pluto.tv/privacy-policy-latam/',
      gsa: 'https://www.de-landing.corp.pluto.tv/datenschutz',
      uk: 'https://www.eu-landing.corp.pluto.tv/privacy-policy',
      es: 'https://www.eu-landing.corp.pluto.tv/politicas-de-privacidad',
      br: 'https://corporate.pluto.tv/privacy-policy-brazil/',
      fr: 'https://www.fr-landing.corp.pluto.tv/politique-de-confidentialite',
    },
  },
  cookie_policy: {
    url: 'https://corporate.pluto.tv/cookie-policy',
    hide: ['latam', 'gsa', 'uk', 'es', 'br', 'fr'],
  },
  cookie_policy_eu: {
    key: 'cookie_policy',
    url: {
      default: 'https://www.eu-landing.corp.pluto.tv/cookie-policy',
      gsa: 'https://www.de-landing.corp.pluto.tv/cookie-richtlinie',
      uk: 'https://www.eu-landing.corp.pluto.tv/cookie-policy',
      es: 'https://www.eu-landing.corp.pluto.tv/politica-de-cookies',
      fr: 'https://www.fr-landing.corp.pluto.tv/politique-de-cookies',
    },
    hide: ['latam', 'us', 'br'],
  },
  do_not_sell_my_personal_information_ccpa: {
    url: 'https://viacomprivacy.com',
    hide: ['latam', 'gsa', 'uk', 'es', 'br', 'fr'],
  },
};

const urlGroups = {
  about: ['welcome', 'about_us', 'careers', 'where_to_watch', 'partners', 'support'],
  legal: [
    'terms_of_use',
    'privacy_policy',
    'cookie_policy',
    'cookie_policy_eu',
    'do_not_sell_my_personal_information_ccpa',
    'terms_and_conditions',
  ],
};

function addUrl(urlKey, region, componentName) {
  const urlConfig = urlsConfig[urlKey];
  if (
    !urlConfig ||
    (urlConfig.hide &&
      (urlConfig.hide.indexOf(region) !== -1 || urlConfig.hide.indexOf(componentName) !== -1))
  ) {
    return null;
  }

  let finalUrl = urlConfig.url;
  if (typeof finalUrl === 'object') {
    finalUrl = finalUrl[region] || finalUrl.default;
  }

  const titleKey = urlConfig.key || urlKey;
  let customTitle;
  if (region === 'gsa') {
    switch (titleKey) {
      case 'terms_of_use':
        customTitle = 'Impressum';
        break;
      case 'privacy_policy':
        customTitle = 'Datenschutzerklärung';
        break;
      case 'cookie_policy_eu':
      case 'cookie_policy':
        customTitle = 'Cookie-Richtlinie';
        break;
      default:
        break;
    }
  }

  return {
    titleKey,
    customTitle,
    url: finalUrl,
  };
}

export const externalUrlsFactory = (marketingRegion = 'us', componentName) => {
  return Object.keys(urlGroups).reduce(
    (final, urlGroup) => ({
      ...final,
      [urlGroup]: urlGroups[urlGroup]
        .map((urlKey) => addUrl(urlKey, marketingRegion, componentName))
        .filter((url) => !!url),
    }),
    {},
  );
};

export const getCookiePolicyUrl = (marketingRegion) => {
  if (marketingRegion === 'us') {
    return urlsConfig.cookie_policy.url;
  }
  if (urlsConfig.cookie_policy_eu.url[marketingRegion]) {
    return urlsConfig.cookie_policy_eu.url[marketingRegion];
  }
  return null;
}